<template>
    <span v-if="mostrarIcone">
        <span class="text-primary ml-1">
            <i
                class="fa fa-file-text fa-lg icon-button"
                title="Justificativa do distrato"
                @click.stop="mostrarDetalhe()"
            ></i>
        </span>
        <b-modal id="modalDetalhe" v-model="mostrarModalDetalhe">
            <div slot="modal-title">Justificativa do Distrato</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <b-form-textarea
                            v-model="etapa.justificativaDistrato"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharDetalhe()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
export default {
    props: {
        etapa: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalhe: false,
            mensagem: ''
        }
    },

    methods: {
        mostrarDetalhe() {
            this.mostrarModalDetalhe = true
        },

        fecharDetalhe() {
            this.mostrarModalDetalhe = false
        }
    },

    computed: {
        mostrarIcone() {
            return (
                this.$temAcessoView('SGTEC-UABS-PRJ-01') &&
                (this.etapa.status == 'CANCELADA' ||
                    this.etapa.status == 'CANCELADO')
            )
        }
    }
}
</script>
